import { Button, Col, Image, Row } from 'antd'
import Link from 'next/link'
import styled from 'styled-components'
import { PROJECT350_URL } from 'utils/constants'

const StyledContainer = styled.div`
  width: 100%;
  cursor: pointer;
  background-image: url('/images/supercard_v2/bonanza-details-banner.png');
  background-size: cover;
  background-position: center;
  min-height: 107px;
  border-radius: 5px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding-left: 24px;
  margin-top: 2rem;
  overflow: visible;
  position: relative;

  .ant-row {
    width: 100%;
    height: 100%;

    .ant-col {
      display: flex;
      align-items: center;
      gap: 14px;

      .ant-btn {
        background: #fbae01;
        color: #000;
        border: #fbae01;
        font-weight: bold;
        margin-right: 40px;
        font-size: 16px !important;
        height: 46px;
      }
    }
  }

  @media (max-width: 576px) {
    padding: 12px 0 12px 16px;
    .ant-col {
      flex-direction: column;
      gap: 0 !important;
    }
    .details {
      text-align: left;
      flex-direction: start;
      align-items: flex-start !important;
    }
    .logo,
    .ant-image {
      width: 100%;
      height: auto !important;
      margin-left: -5px !important;
    }
    .ant-btn {
      font-size: 11px !important;
      height: 25px !important;
    }
  }

  @media (min-width: 577px) and (max-width: 991px) {
    height: 110px;
    padding: 0px 0 12px 24px;
    .details {
      align-items: flex-start !important;
      flex-direction: column;
    }
    .logo,
    .ant-image {
      width: 80%;
      height: auto !important;
      margin-left: -10px;
    }
    .ant-col {
      justify-content: flex-end;
      gap: 0 !important;
    }
    .ant-btn {
      font-size: 11px !important;
      height: 25px !important;
    }
  }
`
const StyledCars = styled.div`
  background-image: url('/images/supercard_v2/bmw.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  width: 250px;
  height: 200px;
  position: absolute;

  @media (max-width: 576px) {
    width: 210px;
    top: -65px;
  }

  @media (min-width: 577px) and (max-width: 912px) {
    width: 320px;
    height: 180px;
  }
`

export default function BonanzaCatalogBanner() {
  return (
    <Link href={PROJECT350_URL}>
      <StyledContainer>
        <Row>
          <Col
            xs={{ span: 14, offset: 0, order: 2 }}
            md={{ span: 14, offset: 0, order: 2 }}
            lg={{ span: 12, offset: 0, order: 1 }}
          >
            <StyledCars />
          </Col>
          <Col
            xs={{ span: 10, offset: 0, order: 1 }}
            md={{ span: 10, offset: 0, order: 1 }}
            lg={{ span: 12, offset: 0, order: 2 }}
            className="details"
          >
            <Image
              className="logo"
              height={100}
              src="/images/supercard_v2/catalog-banner-bonanza.png"
              preview={false}
            />
            <Link href={PROJECT350_URL}>
              <Button type="primary">ENROLL NOW!</Button>
            </Link>
          </Col>
        </Row>
      </StyledContainer>
    </Link>
  )
}
